const _ = require("lodash");
const bookData = require("./data/dbBooks.json");
const StringUtil = require("./StringUtil");
const PageShared = require("./PageShared");

// These functions take frontend page objects and return title and description
// that are used for SEO and the browser title bar.
// See either URLParser or URLMake in shared for a list of possible page
// objects. (URLParser does URL -> page, and URLMake does page -> URL.)

// References:
// - https://blog.kissmetrics.com/the-way-google-scans/

// Turn page into text displayed in browser title bar. Title has SEO meaning,
// but should also make sense for nonindexed pages. For SEO, you get 65
// characters in the title. So for "Beast Academy - ", the suffix should be at
// most 49 characters, and for "Beast Academy Online - ", 42 characters. The
// two lines below can server as a ruler for both.
//  suffix = "This fake suffix value has exactly 49 characters.";
//  suffix = "This fake suffix is exactly 42 characters.";

const getTitle = function(page) {
	const titleSections = ["Beast Academy"];
	let baOnline = false;

	if (page.demo) {
		baOnline = true;
		titleSections.unshift("Demo");
	} else if (page.name === "office.main") {
		titleSections.push("Advanced Math Curriculum for Elementary School");
	} else if (page.name === "office.about") {
		titleSections.unshift("About Us");
	} else if (page.name === "office.apparel") {
		titleSections.unshift("Beast Academy Tee");
	} else if (page.name === "office.bookstore") {
		titleSections.unshift("Math Books for Elementary-Aged Learners");
	} else if (
		page.name === "office.educators" ||
		page.name === "office.outcomes"
	) {
		titleSections.unshift("Math Curriculum for Educators");
	} else if (page.name === "office.book") {
		if (PageShared.isPuzzleBook(page.bookHash)) {
			if (page.bookHash === "puzzles1") {
				titleSections.unshift("Puzzles 1 for Grades 1 and Up");
			} else if (page.bookHash === "puzzles2") {
				titleSections.unshift("Puzzles 2 for Grades 2 and Up");
			} else if (page.bookHash === "puzzles3") {
				titleSections.unshift("Puzzles 3 for Grades 3 and Up");
			} else if (page.bookHash === "puzzles4") {
				titleSections.unshift("Puzzles 4 for Grades 4 and Up");
			} else if (page.bookHash === "puzzles5") {
				titleSections.unshift("Puzzles 5 for Grades 4 and Up");
			}
		} else {
			const baLevel = parseInt(page.bookHash.substr(0, 1));
			titleSections.unshift(
				`Math Book ${page.bookHash} for Grade ${baLevel} Learners`
			);
		}
	} else if (page.name === "office.bookScience") {
		const gradeLevel = parseInt(page.bookHash.substr(0, 1));
		titleSections.unshift(
			`Science Book ${page.bookHash} for Grade ${gradeLevel} Learners`
		);
	} else if (page.name === "office.allbooks") {
		titleSections.unshift("All Math Books");
	} else if (page.name === "office.contact") {
		titleSections.unshift("Contact Us");
	} else if (page.name === "office.faq") {
		titleSections.unshift("FAQs");
		if (page.section === "books") {
			if (
				page.questionHash ===
				"does-beast-academy-follow-the-common-core-standards"
			) {
				titleSections.unshift("Common Core");
			} else if (
				page.questionHash === "which-level-should-my-student-start-at"
			) {
				titleSections.unshift("Curriculum Levels");
			}
		} else if (page.section === "online") {
			if (page.questionHash === "what-does-a-ba-online-subscription-include") {
				titleSections.unshift("Online Subscriptions");
			} else {
				titleSections.unshift("Online Learning");
			}
		} else if (page.section === "orders") {
			if (page.questionHash === "bundle-cancellations") {
				titleSections.unshift("Bundle Cancellations");
			} else if (page.questionHash === "subscription-cancellations") {
				titleSections.unshift("Subscription Cancellations");
			} else if (
				page.questionHash === "what-is-the-refund-policy-for-ba-online-bundles"
			) {
				titleSections.unshift("Refunds for Bundles");
			} else if (
				page.questionHash ===
				"what-is-the-refund-policy-for-monthly-and-yearly-subscriptions"
			) {
				titleSections.unshift("Refunds for Subscriptions");
			} else {
				titleSections.unshift("Orders");
			}
		}
	} else if (page.name === "office.gifting") {
		titleSections.unshift("Gift Beast Academy");
	} else if (page.name === "office.redeemSubscription") {
		titleSections.unshift("Redeem Subscription Codes");
	} else if (page.name === "office.baonline") {
		titleSections.unshift("Learn Math Online for Advanced Elementary Students");
	} else if (page.name === "office.enroll") {
		titleSections.unshift("Enroll in Online Math Learning");
	} else if (page.name === "office.schools") {
		titleSections.unshift("Advanced Math Curriculum for Your Classroom");
	} else if (page.name === "office.termsAndPrivacy") {
		titleSections.unshift("Privacy Policy | Terms and Conditions");
	} else if (page.name === "office.chalkboard") {
		titleSections.unshift("Chalkboard");
	} else if (page.name === "office.resources") {
		titleSections.unshift("Resources");
		if (page.section) {
			const sectionNames = {
				placementtests: "Placement Tests",
				printables: "Printables",
				planning: "Planning",
			};
			const sectionName = sectionNames[page.section];
			if (sectionName) titleSections.unshift(sectionName);
		}
	} else if (page.name === "office.checkout") {
		titleSections.unshift("Cart Checkout");
	} else if (page.name === "parent.main") {
		titleSections.unshift("Parent");
	} else if (page.name === "parent.student") {
		titleSections.unshift("Parent");
	} else if (page.name === "office.mailingList") {
		titleSections.unshift("Mailing List");
		if (page.type) titleSections.unshift(_.startCase(page.type));
	} else if (page.name === "home.main") {
		baOnline = true;
		titleSections.unshift("Home");
	} else if (
		page.name === "trainer.chapter" ||
		page.name === "trainer.problem"
	) {
		baOnline = true;
		titleSections.unshift("Classroom");
		if (page.gradeNumber) {
			titleSections.unshift(`BA Level ${page.gradeNumber}`);
			if (page.chapterIndex) {
				titleSections.unshift(`Chapter ${page.chapterIndex + 1}`);
			}
		}
	} else if (page.name === "trainer.devProblem") {
		baOnline = true;
		titleSections.unshift("DEV PROBLEM PAGE");
	} else if (page.name === "trainer.devEngineTester") {
		baOnline = true;
		titleSections.unshift("ENGINE TESTER");
	} else if (page.name === "profile.main" && page.currentTab === "profile") {
		baOnline = true;
		titleSections.unshift("Student Profile");
	} else if (page.name === "profile.main" && page.currentTab === "progress") {
		baOnline = true;
		titleSections.unshift("Student Progress");
	} else if (page.name === "profile.main" && page.currentTab === "activity") {
		baOnline = true;
		titleSections.unshift("Student Activity");
	} else if (page.name === "profile.selector") {
		baOnline = true;
		titleSections.unshift("Select a Student");
	} else if (page.name === "buildabeast.main") {
		baOnline = true;
		titleSections.unshift("Beast Builder");
	} else {
		// For 404 or anything else, just use Beast Academy as the title.
	}

	if (baOnline) {
		_.map(titleSections, s =>
			s === "Beast Academy" ? "Beast Academy Online" : s
		);
	}
	return titleSections.join(" | ");
};

// Description shown in search engines. No impact on machine SEO, but search
// engines show this below the result, so make this appeal to a human.
const getDescription = function(page) {
	let description;
	if (page.name === "office.main") {
		description =
			"Beast Academy is advanced math curriculum for your child at home. Choose books, online, or both to advance gifted kids in grades 1 to 5.";
	} else if (page.name === "office.apparel") {
		description =
			"Are you a Math Beast? Make sure everyone knows it! This tee-shirt comes in youth and adult sizes. Shop now.";
	} else if (page.name === "office.bookstore") {
		description =
			"Our illustrated math books and puzzles will challenge learners in grades 1 to 5. Complete advanced math curriculum with guide books, worksheeets, and puzzles.";
	} else if (page.name === "office.allbooks") {
		description =
			"Four levels of math books lead gifted learners through an advanced math curriculum. Math books include a guidebook, workbook, and puzzle set. Browse all now.";
	} else if (page.name === "office.baonline") {
		description =
			"Online math is just the ticket for advanced elementary-aged math students. Your learner will play their way through challenging games, practices, and puzzles.";
	} else if (page.name === "office.enroll") {
		description =
			"Enroll in the Beast Academy online math curriculum for advanced kids grades 1 to 5 and challenge your child with guidebooks, practice problems, and puzzles. Enroll now!";
	} else if (page.name === "office.schools") {
		description =
			"Beast Academy's full math curriculum is now available for schools! Find out how to help your school's grade 1 to 5 math students grow.";
	} else if (page.name === "office.faq") {
		description = `When will the next books be published? Which book should my student start with? How is Beast Academy different from other curricula?`;
	} else if (page.name === "office.resources") {
		description = `Beast Academy is a challenging curriculum for students ages 6\u201113. Download printables and placement tests that accompany the books.`;
	} else if (page.name === "office.contact") {
		description =
			"Questions about our math curriculum? Want more info about learning math online? Curious about our challenging math books? We're here to help.";
	} else if (page.name === "office.about") {
		description =
			"The Beast Academy math curriculum was created by the Art of Problem Solving team, which has trained 10s of 1,000s of amazing middle\u2011 and high\u2011school students.";
	} else if (page.name === "office.gifting") {
		description =
			"Give the gift of learning to a loved one for the holidays! Gift a year of Beast Academy now.";
	} else if (page.name === "office.redeemSubscription") {
		description =
			"Redeem your subscription codes for Beast Academy Online, the premier math learning platform. Sign in with a parent account to access discounts on challenging curriculum, interactive puzzles, and personalized learning.";
	} else if (page.name === "office.book") {
		if (PageShared.isPuzzleBook(page.bookHash)) {
			const puzzlesDescriptions = {
				puzzles1:
					"Beast Academy Puzzles 1 is a collection of over 500 puzzles in 12 different styles recommended for grade 1 and up. Shop now.",
				puzzles2:
					"Beast Academy Puzzles 2 is a collection of more than 400 puzzles in 12 different styles recommended for grade 2 and up. Shop now.",
				puzzles3:
					"Beast Academy Puzzles 3 is a collection of nearly 500 puzzles in 12 different styles recommended for grade 3 and up. Shop now.",
				puzzles4:
					"Beast Academy Puzzles 4 is a collection of over 500 puzzles in 12 different styles recommended for grade 4 and up. Shop now.",
				puzzles5:
					"Beast Academy Puzzles 5 is a collection of over 500 puzzles in 12 different styles recommended for grade 5 and up. Shop now.",
			};
			description =
				puzzlesDescriptions[page.bookHash] ||
				"Beast Academy Puzzle books contain hundreds of puzzles in 12 different styles. Shop now.";
		} else {
			if (!bookData[page.bookHash]) {
				return "";
			}
			const stylizedTopics = bookData[page.bookHash].topics.map(t =>
				StringUtil.allWordsLowerCase(t)
			);
			const grade = page.bookHash.substr(0, 1);
			const gradeStr = {
				"2": "2nd",
				"3": "3rd",
				"4": "4th",
				"5": "5th",
			}[grade];
			description = `Beast Academy math curriculum challenges and engages ${gradeStr}\u2011grade students. Unit ${page.bookHash} includes chapters on ${stylizedTopics[0]}, ${stylizedTopics[1]}, and ${stylizedTopics[2]}. Shop Now.`;
		}
	} else if (page.name === "office.termsAndPrivacy") {
		description = `Beast Academy and Art of Problem Solving Privacy, Terms and Conditions`;
	} else if (page.name === "office.bookScience") {
		if (!bookData[page.bookHash]) {
			return "";
		}
		const stylizedTopics = bookData[page.bookHash].topics.map(t =>
			StringUtil.allWordsLowerCase(t)
		);
		const level = page.bookHash.substr(0, 2);
		const gradeLevel = level.substr(0, 1);
		const part = level.substr(1, 1);
		const partWord = part === "A" ? "first" : "second";
		description = `Beast Academy Science ${level} is the ${partWord} part in a two-part series for grade ${gradeLevel} students. Level ${level} includes chapters on ${stylizedTopics[0]}, ${stylizedTopics[1]}, and ${stylizedTopics[2]}.`;
	} else {
		//According to some things, we shouldn't have duplicate metatag descriptions, we should let search engines autogenerate ones for other pages.
		//If we find ones we don't like, then we should fill them in page by page.
		description = "";
	}
	return description;
};

const getCanonicalURL = function(url, page) {
	// Basic canonical ignores query parameters.
	const canonicalURL = url.origin + url.pathname;

	// Do something like this if there are pages that have a custom canonical
	// if (page.name === "office.main") {
	// 	canonicalURL = "https://custom.canonical.url"
	// }

	return canonicalURL;
};

const getKeywords = function(page) {
	let keywords;
	if (page.name === "office.termsAndPrivacy") {
		keywords = `Beast Academy privacy policy terms and conditions, legal`;
	}
	return keywords;
};

module.exports = {
	getTitle,
	getDescription,
	getCanonicalURL,
	getKeywords,
};
